module.exports = __webpack_public_path__ + "media/images/send-e072f88415a9ce39a54798dd975070ff.svg";